import React, { useEffect } from 'react';
import Home from './Home';

const HERO_BACKGROUND =
  "linear-gradient(90deg, rgba(3,10,24,0.58) 0%, rgba(5,16,35,0.50) 48%, rgba(5,16,35,0.32) 100%), url('/img/about-salar-circuit-board.jpg')";

const COMPANY_OVERVIEW_DRIVE_ID = '10Iu9avCZ0LGeDAW5ffMPE9tVSnZXgS3V';

function replacePatentText() {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    const original = node.nodeValue || '';
    const updated = original
      .replace(/Eight USPTO patent filings/g, 'Eleven patent filings')
      .replace(/eight USPTO patent filings/g, 'ten patent filings')
      .replace(/Eight patent areas/g, 'Ten patent areas')
      .replace(/eight patent areas/g, 'eleven patent areas')
      .replace(/Nine patent-pending technology areas/g, 'Ten patent-pending technology areas')
      .replace(/Nine patent filings/g, 'Eleven patent filings')
      .replace(/nine patent filings/g, 'ten patent filings')
      .replace(/Nine patent areas/g, 'Ten patent areas')
      .replace(/nine patent areas/g, 'eleven patent areas')
      .replace(/7 Patent Areas/g, '11 Patent Areas')
      .replace(/8 Patent Areas/g, '11 Patent Areas')
      .replace(/9 Patent Areas/g, '11 Patent Areas')
      .replace(/Backed by 7 pending USPTO patent applications/g, 'Backed by ten patent filings')
      .replace(/Backed by nine patent filings/g, 'Backed by ten patent filings')
      .replace(/all 8 USPTO applications/g, 'all 11 patent filings')
      .replace(/All 8 USPTO applications/g, 'All 11 patent filings')
      .replace(/all 9 patent filings/g, 'all 11 patent filings')
      .replace(/All 9 patent filings/g, 'All 11 patent filings');
    if (updated !== original) node.nodeValue = updated;
  }
}

function applyHomepageHeroVisual() {
  const credibility = document.querySelector('[data-testid="home-hero-credibility"]');
  const hero = credibility?.closest('section');
  if (!hero) return;

  hero.style.background = '#071224';
  hero.style.backgroundImage = HERO_BACKGROUND;
  hero.style.backgroundSize = 'cover';
  hero.style.backgroundPosition = 'center 35%';
  hero.style.backgroundRepeat = 'no-repeat';
  hero.style.minHeight = 'auto';
  hero.style.display = 'block';
  hero.style.paddingTop = '4.5rem';
  hero.style.paddingBottom = '4.5rem';

  hero.querySelectorAll('canvas').forEach((canvas) => {
    canvas.style.display = 'none';
    canvas.setAttribute('aria-hidden', 'true');
  });

  const overlay = hero.querySelector('.absolute.inset-0.pointer-events-none');
  if (overlay) {
    overlay.style.zIndex = '0';
    overlay.style.background =
      'radial-gradient(circle at 74% 46%, rgba(0,212,255,0.16), transparent 35%), linear-gradient(180deg, rgba(3,10,24,0.18), rgba(3,10,24,0.46))';
  }

  const content = hero.querySelector('.container');
  if (content) content.style.zIndex = '1';

  const headline = hero.querySelector('h1');
  if (headline) {
    headline.classList.remove(
      'text-4xl',
      'md:text-5xl',
      'lg:text-6xl',
      'text-5xl',
      'md:text-7xl',
      'lg:text-8xl',
      'font-bold',
      'font-black',
      'tracking-tight',
    );
    headline.classList.add('text-3xl', 'md:text-4xl', 'lg:text-5xl', 'font-semibold');
    headline.style.color = '#ffffff';
    headline.style.lineHeight = '1.16';
    headline.style.fontWeight = '600';
    headline.style.maxWidth = '920px';
    headline.style.marginLeft = 'auto';
    headline.style.marginRight = 'auto';
    headline.style.textShadow = '0 3px 18px rgba(0,0,0,0.7)';
  }

  hero.querySelectorAll('h1 span').forEach((span) => {
    span.style.color = '#ffffff';
    span.style.fontWeight = '600';
    span.style.textShadow = '0 3px 18px rgba(0,0,0,0.7)';
  });

  hero.querySelectorAll('p').forEach((paragraph) => {
    paragraph.style.color = '#ffffff';
    paragraph.style.textShadow = '0 2px 12px rgba(0,0,0,0.75)';
  });

  if (credibility) {
    credibility.classList.remove('text-cyan-300');
    credibility.classList.add('text-white');
    credibility.style.color = '#ffffff';
  }
}

function injectCompanyOverviewVideo() {
  if (document.getElementById('salar-company-overview-video')) return;

  const credibility = document.querySelector('[data-testid="home-hero-credibility"]');
  const hero = credibility?.closest('section');
  const headline = hero?.querySelector('h1');
  if (!hero || !headline) return;

  const videoBlock = document.createElement('div');
  videoBlock.id = 'salar-company-overview-video';
  videoBlock.setAttribute('aria-label', 'SALAR Technologies Company Overview 2026');
  videoBlock.style.maxWidth = '900px';
  videoBlock.style.margin = '1.25rem auto 2.25rem';
  videoBlock.innerHTML = `
    <div style="position:relative;width:100%;aspect-ratio:16/9;background:#020617;border-radius:16px;overflow:hidden;border:1px solid rgba(34,211,238,.30);box-shadow:0 18px 54px rgba(0,0,0,.46);">
      <iframe
        src="https://drive.google.com/file/d/${COMPANY_OVERVIEW_DRIVE_ID}/preview"
        title="SALAR Technologies Company Overview 2026"
        allow="autoplay; fullscreen"
        allowfullscreen
        loading="eager"
        style="position:absolute;inset:0;width:100%;height:100%;border:0;background:#020617;"
      ></iframe>
    </div>
    <div style="display:flex;justify-content:center;margin-top:.75rem;color:#a5f3fc;font-size:.92rem;font-weight:600;">
      SALAR Technologies Company Overview · 1:44
    </div>
  `;

  headline.insertAdjacentElement('beforebegin', videoBlock);
}

export default function HomePatent9() {
  useEffect(() => {
    const run = () => {
      replacePatentText();
      applyHomepageHeroVisual();
      injectCompanyOverviewVideo();
    };

    run();
    const animationFrame = window.requestAnimationFrame(run);
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.cancelAnimationFrame(animationFrame);
      observer.disconnect();
    };
  }, []);

  return <Home />;
}
